module.exports = __webpack_public_path__ + "img/haukkala_sisalta6.37b2ae40.jpg";